document.addEventListener('DOMContentLoaded', function () {
  let $references = document.querySelectorAll('.js-card-overflow');

  $references.forEach(function (item) {
    item.addEventListener('click', function (e) {
      item.classList.toggle('is-active')
    })
  });
});